const DeepLinking = (): null => null;

export { DeepLinking };
